import CartQuery from "theme/pages/Cart/CartQuery.gql";
import CartQtyQuery from "theme/layouts/Header/CartQtyQuery.gql";

const updateCartApolloCache = (store, cart) => {
  store.writeQuery({
    query: CartQtyQuery,
    data: {
      cart: {
        id: cart.id,
        items_qty: cart.items_qty,
        __typename: cart.__typename,
      },
    },
  });

  store.writeQuery({
    query: CartQuery,
    data: { cart: cart },
  });
};

export default updateCartApolloCache;
